<template>
  <div class="registry-list pt-5">
    <div class="header-button">{{ $t('registry.imageList') }}</div>

    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      :moduleName="`registry.imageList`"
    >
      <template v-slot:item.path="{ item }">
        <div
          v-html="$customFunctions.splitContent(item.path, 50)"
          class="cursor-pointer"
          data-toggle="tooltip"
          v-b-tooltip.hover.top="item.path"
        ></div>
      </template>

      <template v-slot:item.is_active="{ item }">
        <Label
          v-if="
            item.is_active.toString().toLowerCase() == 'true' ||
            item.is_active.toString().toLowerCase() == '1'
          "
          class="text-white bg-success"
          >{{ $t('global.true') }}</Label
        >
        <Label v-else class="text-white bg-danger">{{
          $t('global.false')
        }}</Label>
      </template>

      <template v-slot:item.action="{ item }">
        <DeleteButton
          icon="fad fa-trash"
          :title="$t('global.delete')"
          @click.native="openDeleteHandler(item)"
        ></DeleteButton>
      </template>
    </List>
    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'RegistryList',
  data() {
    return {
      loading: false,
      header: [
        {
          text: 'global.name',
          value: 'name',
        },
        {
          text: 'global.os',
          value: 'os',
        },
        {
          text: 'global.distro',
          value: 'distro',
        },
        {
          text: 'global.version',
          value: 'version',
        },
        {
          text: 'global.cpuType',
          value: 'cpu_type',
        },
        // {
        //   text: 'global.extra',
        //   value: 'extra',
        // },
        // {
        //   text: 'global.hash',
        //   value: 'hash',
        //   copyField: true,
        // },
        {
          text: 'global.path',
          value: 'path',
          copyField: true,
          size: '300px',
        },
        { text: 'global.isActive', value: 'is_active', size: '100px' },
        { text: 'global.actions', value: 'action', size: '120px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta
      let $query = `repo/images?docker=true&repoServer=${
        this.$route.params.id
      }&position=id|desc&page=${current_page ? current_page : 1}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `repo/servers/${this.$route.params.id}/docker/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.registry-list {
  .header-button {
    color: #ffffff;
    background: #0a1f44;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    text-transform: uppercase;
    padding: 10px 25px;
    border: 1px solid #eeeff3;
    width: 50%;
  }
}
</style>
